<template>
  <div class="login-container">
    <div class="login-card">
      <div class="img">
        <div class="img-title">
          <div class="school-logo">
            <img src="../../assets/images/logo.png" alt="" />
          </div>
          <div class="split-line"><div class="dashed-line"></div></div>
          <div class="case-center">“立德树人，服务社会”</div>
          <div class="intro">
            抢抓国家大力发展职业教育和“全面融入成渝双城经济圈、推动遂宁和学院高质量发
            展”新机遇，以专业内涵建设为引领、教育教学改革为动力、社会服务品牌为提升、体制机制创新为保障
          </div>
        </div>
        <footer class="login-footer">
          Copyright © 2003-现在 Zhihuishu. All rights reserved.
        </footer>
      </div>
      <div class="login-form-box">
        <div class="login-form" v-if="!showSchoolLogin">
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            auto-complete="on"
          >
            <h3 class="title">账号登录</h3>
            <el-form-item class="login-item" prop="username">
              <el-input
                ref="username"
                placeholder="请输入手机号"
                v-model="loginForm.username"
                name="username"
                tabindex="1"
                type="text"
                auto-complete="on"
                prefix-icon="iconfont iconzhanghao1"
              >
              </el-input>
            </el-form-item>
            <el-form-item class="login-item" prop="password">
              <el-input
                :key="passwordType"
                ref="password"
                v-model="loginForm.password"
                :type="passwordType"
                placeholder="请输入您的密码"
                name="password"
                tabindex="2"
                auto-complete="on"
                prefix-icon="iconfont iconmima1"
                @keyup.enter="handleLogin"
              ></el-input>
            </el-form-item>
            <el-form-item class="login-item-third">
              <!-- <div id="CaptchaEl" ref="CaptchaEl" data-appid="2036785952" data-cbfn="captchaCb" data-module="0" type="primary" style="display:none"></div> -->
              <el-button
                @click.prevent="handleLogin"
                class="login-button"
                type="primary"
                :loading="loading"
                >登&emsp;录</el-button
              >
            </el-form-item>
            <el-form-item class="login-item">
              <!-- <el-checkbox style="float: left" v-model="checked"
              >记住我</el-checkbox
            > -->
              <span
                style="float: right; cursor: pointer"
                :underline="false"
                @click="showReset"
                >忘记密码</span
              >
            </el-form-item>
          </el-form>
          <div class="third-login">
            <h3 class="third-login-title">其他登录方式</h3>
            <div class="other-login">
              <div class="login-content" @click="schoolLogin">
                <div class="third-login-logo1">
                  <img src="../../assets/images/gonghao.png" />
                </div>
                <div class="third-login-link" :underline="false">
                  工号/学号登录
                </div>
              </div>
              <div class="login-content" v-if="showZhs" @click="zhsLogin">
                <div class="third-login-logo">
                  <img
                    src="https://image.zhihuishu.com/zhs/ablecommons/zhangying/202104/57dc6c6595214a2680d5df894df0ccab.png"
                  />
                </div>
                <div class="third-login-link" :underline="false">
                  智慧树登录
                </div>
              </div>
              <div class="login-content" v-if="showSso">
                <div class="third-login-logo3">
                  <img src="../../assets/images/tongyi.png" />
                </div>
                <div class="third-login-link" :underline="false">
                  统一身份登录
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="login-form" v-if="showSchoolLogin">
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            auto-complete="on"
          >
            <h3 class="title">工号/学号登录</h3>
            <!-- <el-form-item class="login-item" prop="schoolName">
              <el-input
                ref="username"
                :value="loginForm.schoolName"
                v-model="loginForm.schoolName"
                name="schoolName"
                tabindex="1"
                type="text"
                auto-complete="on"
                prefix-icon="iconfont iconshou"
              >
              </el-input>
            </el-form-item> -->
            <el-form-item class="login-item" prop="username">
              <el-input
                ref="username"
                placeholder="请输入工号/学号"
                v-model="loginForm.username"
                name="username"
                tabindex="1"
                type="text"
                auto-complete="on"
                prefix-icon="iconfont iconzhanghao1"
                autocomplete="new-password"
              >
              </el-input>
            </el-form-item>
            <el-form-item class="login-item" prop="password">
              <el-input
                :key="passwordType"
                ref="password"
                v-model="loginForm.password"
                :type="passwordType"
                placeholder="请输入您的密码"
                name="password"
                tabindex="2"
                auto-complete="on"
                prefix-icon="iconfont iconmima1"
                @keyup.enter="handleLogin"
              ></el-input>
            </el-form-item>
            <el-form-item class="login-item-third">
              <!-- <div id="CaptchaEl" ref="CaptchaEl" data-appid="2036785952" data-cbfn="captchaCb" data-module="0" type="primary" style="display:none"></div> -->
              <el-button
                @click.prevent="handleLogin"
                class="login-button"
                type="primary"
                :loading="loading"
                >登&emsp;录</el-button
              >
            </el-form-item>
            <el-form-item class="login-item">
              <!-- <el-checkbox style="float: left" v-model="checked"
              >记住我</el-checkbox
            > -->
              <span
                style="float: right; cursor: pointer"
                :underline="false"
                @click="showReset"
                >忘记密码</span
              >
            </el-form-item>
          </el-form>
          <div class="third-login">
            <h3 class="third-login-title">其他登录方式</h3>
            <div class="other-login">
              <!-- <div class="login-content" @click="phoneLogin">
                <div class="third-login-logo1">
                  <img src="../../assets/images/phone.png" style="width: 65%" />
                </div>
                <div class="third-login-link" :underline="false">
                  手机号登录
                </div>
              </div> -->
              <div class="login-content" v-if="showZhs" @click="zhsLogin">
                <div class="third-login-logo">
                  <img
                    src="https://image.zhihuishu.com/zhs/ablecommons/zhangying/202104/57dc6c6595214a2680d5df894df0ccab.png"
                  />
                </div>
                <div class="third-login-link" :underline="false">
                  智慧树登录
                </div>
              </div>
              <div class="login-content" v-if="showSso">
                <div class="third-login-logo3">
                  <img src="../../assets/images/tongyi.png" />
                </div>
                <div class="third-login-link" :underline="false">
                  统一身份登录
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 忘记密码弹框 -->
    <div class="change-dialog">
      <el-dialog
        title="重置密码"
        width="400px"
        v-model="showResetDialog"
        destroy-on-close
        center
      >
        <div class="tips">验证码将会发送至您的绑定手机</div>
        <div class="reset-form">
          <el-form
            ref="resetForm"
            :model="resetForm"
            :rules="resetRules"
            auto-complete="on"
          >
            <el-form-item class="login-item" prop="phoneNumber">
              <el-input
                placeholder="请输入您的手机号码"
                v-model="resetForm.phoneNumber"
                name="phoneNumber"
                auto-complete="on"
              >
                <template #prepend
                  ><i class="el-icon-mobile-phone"></i
                ></template>
              </el-input>
            </el-form-item>
            <el-form-item class="login-item" prop="code">
              <el-input
                class="input-code"
                v-model="resetForm.code"
                placeholder="请输入您的手机验证码"
                autocomplete="new-password"
              >
                <template #prepend>
                  <i class="el-icon-chat-dot-round"></i>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item class="login-item" prop="password">
              <el-input
                v-model="resetForm.password"
                type="password"
                placeholder="8-16位大小写字母和数字的新密码"
                autocomplete="new-password"
                ><template #prepend><i class="iconfont iconmima1"></i></template
              ></el-input>
            </el-form-item>
            <el-form-item class="login-item" prop="copyPassword">
              <el-input
                v-model="resetForm.copyPassword"
                type="password"
                placeholder="请再次输入新密码"
                ><template #prepend><i class="iconfont iconmima1"></i></template
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="code-text">
            <div class="code-get" v-if="codeShow" @click="getCode">
              <el-button type="text">获取验证码</el-button>
            </div>
            <div class="code-get" v-if="!codeShow">
              <el-button type="text">{{ count }}秒后重新发送</el-button>
            </div>
          </div>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <div
              id="CaptchaEl"
              ref="CaptchaEl"
              data-appid="2036785952"
              data-cbfn="captchaCb"
              data-module="0"
              type="primary"
              style="display: none"
            ></div>
            <el-button type="primary" @click="confirmReset">确认重置</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { ElMessage } from "element-plus";
export default {
  name: "login",
  created() {
    // console.log(this.url)
    this.getObjectStatus();
    this.getBaseSet();
    this.getUserInfoLogin();
    // this.validTicket()
    console.log(this.$utils.getService());
  },
  mounted() {
    window.captchaCb = (res) => {
      console.log(res);
      this.randstr = res.randstr;
      this.ticket = res.ticket;
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      if (res.ret === 0) {
        this.sendCode();
      }
      return Promise.reject();
    };
  },
  data() {
    let RegPhone = /^[1][34578][0-9]{9}$/;
    let RegResetPass =
      /^(?![0-9]+$)(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入您的账号"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 4) {
        callback(new Error("用户名或密码错误"));
      } else {
        callback();
      }
    };
    const validPhoneNumber = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入您的手机号"));
      } else if (!RegPhone.test(value)) {
        callback(new Error("手机号码格式不正确"));
      } else {
        callback();
      }
    };

    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!RegResetPass.test(value)) {
        callback(new Error("请输入8-16位密码(大小写字母+数字)"));
      } else {
        if (this.resetForm.copyPassword !== "") {
          this.$refs.resetForm.validateField("copyPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.resetForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      // url: location.href.substring(location.href.indexOf('?') + 1),
      url: location.href,
      loginForm: {
        username: "",
        password: "",
        schoolName: process.env.VUE_APP_PROJECT_NAME + '',
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },
      resetRules: {
        phoneNumber: [
          { required: true, trigger: "blur", validator: validPhoneNumber },
        ],
        code: [
          { required: true, trigger: "blur", message: "请输入验证码" },
          { min: 4, max: 4, message: "请输入四位验证码", trigger: "blur" },
        ],
        password: [
          { validator: validatePass, required: true, trigger: "blur" },
        ],
        copyPassword: [
          { validator: validatePass2, required: true, trigger: "blur" },
        ],
      },
      loading: false,
      passwordType: "password",
      redirect: undefined,
      userInfo: {},
      showChangeDialog: false,
      captchaValid: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        copyNewword: "",
      },
      showResetDialog: false,
      resetForm: {
        userName: "",
        phoneNumber: "",
        code: "",
        password: "",
        copyPassword: "",
      },
      timer: null,
      count: "",
      codeShow: true,
      randstr: "",
      ticket: "",
      codeSuccess: false,
      showSchoolLogin: true,
      logInType: 2,
      showZhs: false,
      showSso: false,
    };
  },
  computed: {
    noTicketUrl() {
      return this.$utils.removeUrlParam(["ticket"]);
    },
  },
  methods: {
    async getUserInfo() {
      let params = {
        password: this.loginForm.password,
        username: this.loginForm.username,
        logInType: this.logInType,
      };
      const res = await this.$http.getLogin(params, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log(res);
      if (res.token) this.$utils.setCookie("X-Access-Token", res.token);
      this.userInfo = res;
      console.log("用户信息", this.userInfo);
      // window.location.href = `${this.$baseUrl}/index.html`
    },
    // 点击登录
    handleLogin(e) {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.getUserInfo()
            .then((res) => {
              if (this.$utils.getUrlParams('service')) {
                window.location.href = this.$utils.getUrlParams('service')
              } else {
                window.location.href = `/index.html`;
              }
            })
            .catch((error) => {
              this.loading = false;
              console.log("1234", error);
              // ElMessage.error(error.data.message)
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    zhsLogin() {
       const host = window.location.protocol + '//' + window.location.host
      const loginUrl = host + '/login.html'
      const url = host + '/index.html'
      window.location.href = `${host}/hike-boot/AuthSys/getAuthorize?redirectUri=${url}&failRedirectUri=${loginUrl}`
      // window.location.href = `https://passport.zhihuishu.com/login?service=${this.url}`;
    },
    closeHandle() {
      window.location.href = `${this.$baseUrl}/index.html`;
    },
    async changePassword() {
      let params = {
        fomrerPassword: this.passwordForm.oldPassword,
        newPassword: this.passwordForm.newPassword,
        username: this.loginForm.username,
      };
      const res = await this.$http.changePassword(params);
      console.log(res);
    },
    showReset() {
      this.showResetDialog = true;
    },
    // 学号登录
    schoolLogin() {
      this.logInType = 2;
      this.showSchoolLogin = true;
    },
    // 手机号登录
    phoneLogin() {
      this.showSchoolLogin = false;
      this.logInType = 1;
    },
    // 确认重置
    async submitInfo() {
      let params1 = {
        code: this.resetForm.code,
        mobile: this.resetForm.phoneNumber,
      };
      let params = {
        code: this.resetForm.code,
        mobile: this.resetForm.phoneNumber,
        newPassword: this.resetForm.password,
        // username: this.resetForm.phoneNumber
      };
      const res1 = await this.$http.validateCode(params1, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      console.log(res1);
      if (res1 == false) {
        return ElMessage.error("您输入的验证码不正确");
      } else {
        const res = await this.$http.resetPass(params, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });
        console.log(res);
        window.location.href = `${this.$baseUrl}/login.html`;
        ElMessage("请使用新密码登录");
      }
    },
    confirmReset() {
      this.$refs.resetForm.validate((valid) => {
        if (valid) {
          this.submitInfo()
            .then(() => {
              // window.location.href = `${this.$baseUrl}/login.html`
            })
            .catch((error) => {
              ElMessage(error.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCode() {
      let Reg = /^[1][34578][0-9]{9}$/;
      if (!this.resetForm.phoneNumber) {
        ElMessage.warning({
          message: "请先输入您的手机号码",
          type: "warning",
        });
        return;
      } else {
        if (Reg.test(this.resetForm.phoneNumber)) {
          console.log("111");
          let btn2 = document.getElementById("CaptchaEl");
          console.log(btn2);
          btn2.click();
          console.log("222");
        } else {
          ElMessage.warning({
            message: "手机号码格式不正确",
            type: "warning",
          });
        }
      }
    },
    async codeMessage() {
      let params = {
        mobile: this.resetForm.phoneNumber,
        randStr: this.randstr,
        ticket: this.ticket,
        username: this.resetForm.phoneNumber,
        logInType: 1,
      };
      const res = await this.$http.getMessage(params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      console.log(res);
      this.codeSuccess = res;
    },
    async sendCode() {
      console.log(this.randstr);
      this.codeMessage()
        .then(() => {
          if (this.codeSuccess) {
            const timeCount = 60;
            if (!this.timer) {
              this.count = timeCount;
              this.codeShow = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= timeCount) {
                  this.count--;
                } else {
                  this.codeShow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            ElMessage.warning({
              message: "请稍后再试",
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          // ElMessage.warning({
          //   message: error.data.message,
          //   type: 'warning'
          // })
        });
      console.log("123");
    },
    async getBaseSet() {
      const res = await this.$http.getBaseSet();
      this.showZhs = res.zhs_login;
      this.showSso = res.sso_login;
      // console.log('基础配置信息', res);
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = res.icon_url;
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    // ticket校验
    async validTicket() {
      const params = {
        service: this.noTicketUrl,
        ticket: this.$utils.getUrlParams("ticket"),
      };
      const validInfo = await this.$http.validateTicket(params);
      if (validInfo.token)
        this.$utils.setCookie("X-Access-Token", validInfo.token);
      if (validInfo.userInfo) {
        this.userInfo = validInfo.userInfo;
        // this.$emit('getUserInfo', this.userInfo)
        window.location.href = "/index.html";
      }
      // 是否需要登录
      if (!validInfo && this.isNeedLogin) {
        window.location.href = this.loginUrl;
      }
    },
    // 获取用户信息
    async getUserInfoLogin() {
      let token = this.$utils.getCookie("X-Access-Token");
      let ticket = this.$utils.getUrlParams("ticket");
      if (token) {
        const userInfo = await this.$http.getUserInfo();
        this.userInfo = userInfo;
        window.location.href = "/index.html";
        console.log("用户信息", userInfo);
        // this.$emit('getUserInfo', userInfo)
        return;
      }
      if (ticket) {
        this.validTicket();
        return;
      }
      // 是否需要登录
      if (this.isNeedLogin) {
        window.location.href = "/login.html";
      }
      return null;
    },
    // 项目状态
    async getObjectStatus() {
      const res = await this.$http.getObjectStatus();
      console.log("状态", res);
      if (!res.status) {
        window.location.href = "/stop.html";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.login-container {
  height: 100vh;
  position: relative;
  .login-card {
    width: 100vw;
    height: 100%;
    display: flex;
    .img {
      flex: 2;
      height: 100%;
      background-image: url(../../assets/images/login_bg.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      // background-color: $--color-primary;
      position: relative;
      .img-title {
        position: absolute;
        width: 100%;
        top: 25%;
      }
      .school-logo {
        margin: 0 auto;
        width: 449px;
        img {
          width: 100%;
          object-fit: cover;
        }
      }
      .split-line {
        position: relative;
        margin: 48px auto 0;
        width: 475px;
        height: 2px;
        border-top: 2px solid #fff;
        .dashed-line {
          position: absolute;
          top: 8px;
          left: 0;
          width: 475px;
          height: 1px;
          border-top: 1px dashed #fff;
        }
      }
      .case-center {
        margin: 39px auto 0;
        width: 440px;
        height: 60px;
        font-size: 40px;
        font-family: slideyouran-Regular, slideyouran;
        font-weight: 400;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .intro {
        margin: 24px auto 0;
        width: 669px;
        height: 64px;
        padding: 0 30px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 32px;
      }
      .login-footer {
        width: 100%;
        height: 20px;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #fff;
        line-height: 18px;
        position: absolute;
        bottom: 5%;
      }
    }
    .login-form-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .login-form {
      width: 60%;
      margin: 0 auto;
      text-align: center;
      .title {
        font-size: 18px;
        font-weight: 600;
        color: #2a2a2a;
        line-height: 25px;
        margin-bottom: 25px;
        text-align: left;
      }
      .login-item {
        margin-bottom: 20px;
        &-third {
          margin-bottom: 5px;
        }
        :deep(.el-input-group__prepend) {
          padding: 10px 12px;
          background-color: #fff;
        }
        :deep(.el-input__inner) {
          height: 44px;
          padding-left: 45px;
          text-indent: 10px;
        }
        :deep(.el-input__prefix) {
          height: 36px;
          color: #7e7e7e;
          top: 4px;
          left: 14px;
          padding-right: 12px;
          border-right: 1px solid #ededed;
        }
      }
      .login-button {
        margin-top: 10px;
        width: 100%;
        height: 44px;
        &:hover {
          filter: grayscale(20%);
        }
      }
    }
    .third-login {
      color: #2a2a2a;
      &-title {
        background: url(https://image.zhihuishu.com/zhs/ablecommons/zhangying/202104/40671ccdacdf47fa88d3a2446cab69b9.png)
          no-repeat center;
        background-size: auto 1px;
        font-size: 18px;
        font-weight: 600;
        line-height: 25px;
      }
      .other-login {
        display: flex;
        justify-content: space-evenly;
      }
      // third-login-logo
      &-logo {
        width: 48px;
        height: 48px;
        border: solid 1px #ddd;
        border-radius: 50%;
        padding: 15px 10px;
        margin: 25px auto 14px;
        cursor: pointer;
        &:hover {
          border-color: $--color-primary;
        }
        img {
          width: 100%;
          object-fit: cover;
        }
      }
      &-logo1 {
        width: 48px;
        height: 48px;
        border: solid 1px #ddd;
        border-radius: 50%;
        padding: 13px 10px;
        margin: 25px auto 14px;
        cursor: pointer;
        &:hover {
          border-color: $--color-primary;
        }
        img {
          width: 100%;
          object-fit: cover;
        }
      }
      &-logo3 {
        width: 48px;
        height: 48px;
        border: solid 1px #ddd;
        border-radius: 50%;
        padding: 12px 10px;
        margin: 25px auto 14px;
        img {
          width: 100%;
        }
      }
      &-link {
        margin: 0 auto;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        cursor: pointer;
        &:hover {
          color: $--color-primary;
        }
      }
    }
  }
}

.change-dialog {
  width: 400px;
  .tips {
    width: 100%;
    margin-bottom: 25px;
    text-align: center;
  }
  .dialog-footer {
    width: 100%;
  }
}
:deep(.el-dialog) {
  width: 400px;
  .el-dialog__header {
    padding-bottom: 0;
  }
  .el-dialog__body {
    text-align: center;
    padding: 5px 25px 30px;
  }
}
.reset-form {
  .input-code {
    position: relative;
  }
  :deep(.el-input) {
    position: relative;
  }
  :deep(.el-button) {
    position: absolute;
    top: 0;
    right: 0;
    // z-index: 9999;
  }
  .code-text {
    position: absolute;
    top: 155px;
    right: 30px;
    cursor: pointer;
    // padding: 0 10px;
    font-size: 12px;
    .code-time {
      margin-top: -2px;
      transform: scale(0.8);
    }
  }
}
</style>